import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

  @ViewChild('mapContainer') gmap: ElementRef;
  @ViewChild('btnComb') public btnComb: ElementRef;

  addDataComb: FormGroup;
   
  title = 'angular-agm';

  formErrors = {
    "depreg": "",
    "deptsc": "",
    "number": "",
    "number2": "",
    "number3": "",
    "depregcomb": "",
  };

  validationMessages = {
    "depreg": {
        "required": "Обов'якове поле.",
        "captchaValidator": "Підтвердіть Recaptcha додатково.",
    },
    "depregcomb": {
      "required": "Обов'якове поле.",
  },
    "deptsc": {
        "required": "Обов'якове поле.",
        "captchaValidator": "Підтвердіть Recaptcha додатково.",
 
    },
    "number": {
      "required": "Обов'якове поле.",
      "pattern": "Мають бути цілі числа.              ",
      "maxlength": "Максимум 10 цифр.              ",
      "minlength": "Мінімум 10 цифр.  ",
  },
  "number2": {
    "required": "Обов'якове поле.",
    "pattern": "Мають бути цілі числа.              ",
    "maxlength": "Максимум 10 цифр.              ",
    "minlength": "Мінімум 10 цифр.  ",
},
"number3": {
  "required": "Обов'якове поле.",
  "pattern": "Мають бути цілі числа.              ",
  "maxlength": "Максимум 9 цифр.              ",
  "minlength": "Мінімум 9 цифр.  ",
  "captchaValidatorPl": "Підтвердіть Recaptcha додатково.",
}
  };

  constructor(private router: Router, private http: HttpClient, private fb: FormBuilder) { }

  ngOnInit() {

    this.buildFormComb();

  }

  buildFormComb() {
    this.addDataComb = this.fb.group({
        "number": ['', [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10),
            Validators.pattern("\\d+"),
        ]],
        "number2": ['', [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern("\\d+"),
      ]],
      "number3": ['', [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(9),
        Validators.pattern("\\d+"),
    ]],
    });

    this.addDataComb.valueChanges
        .subscribe(data => this.onValueChangeComb(data));

    this.onValueChangeComb();
    
    if (this.addDataComb.valid) {
      this.btnComb.nativeElement.className = "button_success";
    }

  }

  onValueChangeComb(data?: any) {

    if (!this.addDataComb) return;
    let form = this.addDataComb;

    for (let field in this.formErrors) {
        this.formErrors[field] = "";
      
        let control = form.get(field);

        if (control && control.dirty && !control.valid) {
            let message = this.validationMessages[field];
            for (let key in control.errors) {
                this.formErrors[field] += message[key] + " ";
            }
        }
    }
  } 

  backToMain() {
    this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
    this.router.navigate(['/']);
    });
  }


  fetchDnzNumb(inn_buy:any, inn_sell:any, car_id:any) {
    console.log('bla');

    const body = new HttpParams()
    .set('buyer', inn_buy)
    .set('seller', inn_sell)
    .set('car', car_id);

    alert(body);
    
    this.http.get('https://mainapi.hsc.gov.ua/licenseplate-service/whs/plates/regnum?regionid=' + inn_buy + '&number=' + inn_sell)
    .subscribe (
      data => {
        // console.log(data);
        //  this.dnzCombinationSelect = data;
         if (data != null) {
        //  console.log('Its pv');
      //    this.dnzParameters.forEach( (item:any) => {
      //    this.dnzParameters = item.categories;
      //   //  console.log(this.pvCategories);
      // this.dtTriggerPlate.next();

      // let currentDatePl = moment().locale('uk');
      // this.timePl = currentDatePl.format('DD.MM.YYYY HH:mm:ss');

      const outData: HTMLElement = document.getElementById('four');
      const enterParam: HTMLElement = document.getElementById('three');

      enterParam.classList.add('animate__animated', 'animate__zoomOutDown');
      setTimeout(() => enterParam.hidden = true, 900);

      outData.classList.add('animate__animated', 'animate__zoomInDown');
      setTimeout(() => document.getElementById("four").style.display = "block", 900);

      //  });
      } else {
        console.log('Not found '); 
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['message']);
          }); 
      }
    },
         err => console.log(err)
    )

}

}
